import { combineReducers } from "@reduxjs/toolkit";
import data from "./dataSlice";
import state from "./stateSlice";
const buyerReducer = combineReducers({
  data,
  state,
});

export default buyerReducer;
